import { useQuery } from '@tanstack/react-query';

import { libraryApi } from '../api/library.api.js';

export function useUpcomingReleases(limit = 5) {
  return useQuery({
    queryKey: ['upcoming', limit],
    queryFn: () => libraryApi.listUpcomingReleases(limit),
    staleTime: 5 * 60 * 1000,
  });
}
